var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('QuestionInfo',{attrs:{"mainQuestionId":_vm.question.id,"mainQuestionIndex":_vm.questionIndex,"questions":_vm.question.subQuestions,"section":_vm.section,"sectionIndex":_vm.sectionIndex,"isSubQuestion":_vm.isSubQuestion,"isBundle":_vm.isBundle}}),_c('div',{staticClass:"button-create-new mt-4"},[_c('b-button',{attrs:{"right":"","variant":"primary","no-caret":"","active":""},on:{"click":function($event){return _vm.generateSubQuestion(
          _vm.section.id,
          _vm.sectionIndex,
          _vm.question.id,
          _vm.questionIndex
        )}}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" เพิ่มคำถามย่อย ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }